import { render, staticRenderFns } from "./SoundRightsRecordDialog.vue?vue&type=template&id=5d3ba95c&scoped=true"
import script from "./SoundRightsRecordDialog.vue?vue&type=script&lang=js"
export * from "./SoundRightsRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./SoundRightsRecordDialog.vue?vue&type=style&index=0&id=5d3ba95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ba95c",
  null
  
)

export default component.exports